import { useMemo } from 'react'
import { CssBaseline, ThemeProvider, StyledEngineProvider } from '@mui/material'

import { getCustomTheme } from 'features/common/ui/theme/cartoTheme'
import { useBranding } from 'features/branding/hooks/brandingHooks'
import { useAppSelector } from 'app/state'

function CloudNativeThemeProvider({ children }) {
  const { data: branding } = useBranding()
  const mapBranding = useAppSelector((state) => state.maps.currentMap?.branding)

  const theme = useMemo(() => getCustomTheme(mapBranding || branding), [mapBranding, branding])

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default CloudNativeThemeProvider
